import _ from 'lodash'

import template from './index.html'
import repeatController from '../../../../ui-formly/types/repeater/controller'
import { defaultModelOptions } from '../../../../utils/modelOptions'
import fieldHelpers from '../../../../ui-formly/fieldHelpers/index'
import { vsName as ValidatorsName } from '../../../common/validation/validators'
import PreviousFieldController from '../../../common/ui-formly/controllers/PreviousFieldController'

import machineServer from '../../Server'

const indexRegex = /\[(\d+)\]/

formly.$inject = [ValidatorsName]
function formly(validators) {
  var modelOptions = defaultModelOptions

  var locationValidators = {
    collectionLocation: {
      expression: validators.allLocationsDifferent
    }
  }

  var locationValidation = {
    messages: {
      collectionLocation: function () {
        return 'Locations must be unique'
      }
    }
  }

  const repeaterFields = [
    {
      className: 'row',
      fieldGroup: [
        fieldHelpers.simpleReadonlyField({ key: 'SerialNumber', label: 'Serial Number', className: 'col-xs-2' }),
        fieldHelpers.simpleReadonlyField({ key: 'SlotNumber', label: 'Asset Number', className: 'col-xs-1' }),
        {
          key: "MachineAreaId",
          name: "MachineAreaId",
          type: "selectAsync",
          templateOptions: {
            label: "Area",
            required: true,
            query: [machineServer.vsName, function (server) {
              return function (search) {
                return server.machineAreaQuery({
                  NameContains: search,
                  Skip: 0,
                  Take: 25,
                  OrderBy: 'Name'
                })
              }
            }],
            saveNewItem: [machineServer.vsName, function (server) {
              return function (name) {
                return server.machineAreaSave({
                  Name: name
                })
              }
            }],
            getDefaultItem: function (model) {
              return {
                Id: model.MachineAreaId,
                Name: model.MachineAreaName
              }
            },
            updateNameProp: 'MachineAreaName'
          },
          expressionProperties: {
            'templateOptions.helpText': ($viewValue, $modelValue, $scope) => {
              return `Previous: ${$scope.model.PreviousMachineAreaName}`
            }
          },
          className: 'col-xs-2'
        },
        getLocationField({ key: 'Section' }),
        getLocationField({ key: 'Bank' }),
        getLocationField({ key: 'Slot' }),
        {
          key: "MachineBankConfigId",
          name: "MachineBankConfigId",
          type: "selectAsync",
          templateOptions: {
            label: "Bank Config",
            required: true,
            query: [machineServer.vsName, function (server) {
              return function (search) {
                return server.machineBankConfigQuery({
                  NameContains: search,
                  Skip: 0,
                  Take: 25,
                  OrderBy: 'Name'
                })
              }
            }],
            saveNewItem: [machineServer.vsName, function (server) {
              return function (name) {
                return server.machineBankConfigSave({
                  Name: name
                })
              }
            }],
            getDefaultItem: function (model) {
              return {
                Id: model.MachineBankConfigId,
                Name: model.MachineBankConfigName
              }
            },
            updateNameProp: 'MachineBankConfigName'
          },
          expressionProperties: {
            'templateOptions.helpText': ($viewValue, $modelValue, $scope) => {
              return `Previous: ${$scope.model.PreviousMachineBankConfigName}`
            }
          },
          className: 'col-xs-2'
        },
        {
          key: 'copyDown',
          controller: ['$scope', function ($scope) {
            $scope.copyDownLocationFields = () => {
              const id = $scope.id
              const objectCollection = findCollection($scope)
              const index = Number.parseInt(id.match(indexRegex)[1])

              const copyFields = {
                MachineAreaId: $scope.model.MachineAreaId,
                Section: $scope.model.Section,
                Bank: $scope.model.Bank,
                Slot: null,
                MachineBankConfigId: $scope.model.MachineBankConfigId
              }

              _.chain(objectCollection)
                .drop(index + 1)
                .forEach(collectionObject => {
                  _.assign(collectionObject, copyFields)
                })
                .value()
            }
          }],
          template: '<div class="form-group"><label class="form-label">&nbsp;</label><div><button type="button" class="btn btn-primary" ng-click="copyDownLocationFields()"><i class="fa fa-arrow-down" /></button></div></div>'
        }
      ]
    }
  ]

  var fields = _.flatten([
    fieldHelpers.columnLayout([
      fieldHelpers.simpleDateField({ key: 'Date', label: 'Move Date', required: true })
    ], 3),
    fieldHelpers.columnLayout([{
      key: 'MachineMoves',
      name: 'MachineMoves',
      controller: repeatController,
      templateUrl: template,
      templateOptions: {
        fields: repeaterFields
      }
    }], 1),
    {
      key: 'Files',
      name: 'Files',
      type: 'fileUpload',
      templateOptions: {
        label: 'Files'
      }
    },
    fieldHelpers.columnLayout([
      fieldHelpers.textAreaField({ key: 'Notes' })
    ], 1)
  ])

  return fields

  function findCollection(scope) {
    if (!scope) {
      return null
    }
    if (scope.repeaterCollection) {
      return scope.repeaterCollection
    }

    return findCollection(scope.$parent)
  }

  function getPreviousField(config) {
    return {
      key: config.key,
      name: config.key,
      type: 'input',
      templateOptions: {
        label: _.startCase(config.key),
        required: true
      },
      controller: PreviousFieldController,
      className: config.className ? config.className : 'col-xs-1'
    }
  }

  function getLocationField(config) {
    const locationFields = {
      validators: locationValidators,
      validation: locationValidation,
      modelOptions: modelOptions
    }

    const field = { ...getPreviousField(config), ...locationFields }
    return field
  }
}

export default formly